import { loadStripe } from '@stripe/stripe-js';
import api from './api';

let stripePromise = null;

async function getStripe() {
  if (!stripePromise) {
    const { data } = await api.get('/stripe/config');
    stripePromise = loadStripe(data.publishableKey);
  }
  return stripePromise;
}

export const stripeService = {
  async createCheckoutSession(priceId, customerId, successUrl, cancelUrl) {
    try {
      const response = await api.post('/stripe/create-checkout-session', {
        priceId,
        customerId,
        successUrl,
        cancelUrl
      });
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  async createCustomerPortalSession(customerId) {
    try {
      const response = await api.post('/stripe/create-customer-portal-session', {
        customerId
      });
      return response.data;
    } catch (error) {
      console.error('Error creating customer portal session:', error);
      throw error;
    }
  },

  async getPricing() {
    try {
      const response = await api.get('/stripe/pricing');
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing:', error);
      throw error;
    }
  },

  async redirectToCheckout(sessionId) {
    const stripe = await getStripe();
    const { error } = await stripe.redirectToCheckout({
      sessionId
    });

    if (error) {
      console.error('Error redirecting to checkout:', error);
      throw error;
    }
  },

  async getSubscriptionDetails() {
    try {
      const response = await api.get('/stripe/subscription');
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      throw error;
    }
  },

  async getBillingInfo() {
    try {
      const response = await api.get('/stripe/billing');
      return response.data;
    } catch (error) {
      console.error('Error fetching billing info:', error);
      throw error;
    }
  },

  async getInvoices() {
    try {
      const response = await api.get('/stripe/invoices');
      return response.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },

  async cancelSubscription() {
    try {
      const response = await api.post('/stripe/cancel-subscription');
      return response.data;
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      throw error;
    }
  }
};

export default stripeService;